module.exports = __webpack_public_path__ + "static/media/comp1.02ae0608.jpg";